import { AxiosResponseHeaders } from "axios";
import { IApiClient } from "../api-client";
import { EnvType } from "../services";
import { DbKdmRecipientInfos } from "../Types/db-kdm-recipient-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { KdmListResponse } from "../Types/kdm-list-response";

interface IDciApiClient {
  UploadDkdm(
    objectId: number,
    fileToUpload: File,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<GenericResponseStd>;
  ListKdmRecipients(): Promise<KdmListResponse>;
  DownloadKdmRecipientCert(objectId: number): string;
  CreateKdmRecipient(request: DbKdmRecipientInfos): Promise<GenericResponseStd>;
  UpdateKdmRecipient(request: DbKdmRecipientInfos): Promise<GenericResponseStd>;
  DeleteKdmRecipient(objectId: number): Promise<GenericResponseStd>;
  DownloadKdmPublicCert(): Promise<[string, AxiosResponseHeaders]>;
}

export default class DciApiClient implements IDciApiClient {
  readonly servicePort = 9521;
  readonly serviceBaseUrl = "dci-service/api";

  dciApiClient: IApiClient;

  constructor(fileApiClient: IApiClient, envType: EnvType) {
    this.dciApiClient = fileApiClient;
    if (envType === "local") this.dciApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async UploadDkdm(
    objectId: number,
    fileToUpload: File,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<GenericResponseStd> {
    const formData = new FormData();
    formData.append("file", fileToUpload);

    return await this.dciApiClient.postUploadFormData(
      `${this.serviceBaseUrl}/kdm/dkdm/upload/${objectId}`,
      formData,
      abortSignal,
      onUploadProgressCallback
    );
  }

  async ListKdmRecipients(): Promise<KdmListResponse> {
    return await this.dciApiClient.get(`${this.serviceBaseUrl}/recipients`);
  }

  async CreateKdmRecipient(request: DbKdmRecipientInfos): Promise<GenericResponseStd> {
    return await this.dciApiClient.post(`${this.serviceBaseUrl}/recipients`, request);
  }

  async UpdateKdmRecipient(request: DbKdmRecipientInfos): Promise<GenericResponseStd> {
    return await this.dciApiClient.put(`${this.serviceBaseUrl}/recipients`, request);
  }

  async DeleteKdmRecipient(objectId: number): Promise<GenericResponseStd> {
    return await this.dciApiClient.delete(`${this.serviceBaseUrl}/recipients/${objectId}`);
  }

  async SyncKdmRecipients(): Promise<GenericResponseStd> {
    return await this.dciApiClient.put(`${this.serviceBaseUrl}/recipients/sync`);
  }

  DownloadKdmRecipientCert(objectId: number): string {
    return this.dciApiClient.client.defaults.baseURL + `${this.serviceBaseUrl}/recipients/${objectId}`;
  }

  async DownloadKdmPublicCert(): Promise<[string, AxiosResponseHeaders]> {
    return await this.dciApiClient.getWithHeaders(`${this.serviceBaseUrl}/cert`, "arraybuffer");
  }

  //------Utils------
  GetApiUrl(): string {
    return this.dciApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
